//TODO:  Do we need substate for this Task Object State???   Split into SubState like Contract?

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppService } from '@Core/services/proprietary/app.service';
import { cloneDeep } from 'src/ep-utils';
import { PrepareRequest, ResetState, SetProjectObjectState, UpdateProject } from './project-object.actions';

export interface ProjectObjectStateModel {
    entities: any;
    project: any;
    currentProjectID: string;
}

const ProjectObjectStateDefaults: ProjectObjectStateModel = {
    entities: {},
    project: {},
    currentProjectID: null
};

@State<ProjectObjectStateModel>({
    name: 'projectObjectState',
    defaults: ProjectObjectStateDefaults
})
@Injectable()
export class ProjectObjectState {
    constructor(private app: AppService) { }

    @Selector()
    static entities(state: ProjectObjectStateModel) {
        let tempEntities = { ...state.entities };
        tempEntities.Project = state.project;
        return tempEntities;
    }

    @Selector()
    static project(state: ProjectObjectStateModel) {
        return state.project[state.currentProjectID] || null;
    }

    @Action(UpdateProject)
    updateProject(sc: StateContext<ProjectObjectStateModel>, action: UpdateProject) {
        const state = sc.getState();
        const projectID = action.project.Project_ID;
        if (!projectID) {
            return;
        }
        const currentProject = state.project[projectID];
        let updateProject: any = { ...action.project }; //need DEEP copy?

        sc.patchState({
            project: {
                ...state.project,
                [projectID]: { ...currentProject, ...updateProject }
            }
        });
    }

    @Action(SetProjectObjectState)
    setProjectObjectState(sc: StateContext<ProjectObjectStateModel>, action: SetProjectObjectState) {
        //const state = sc.getState();

        let projectID = null;
        for (var j in action.entities.Project) {
            projectID = j;
            break;
        }

        // copy references to raw normalized entities and then remove the entities that have thier own state
        let entities = { ...action.entities };

        // Make sure that entities "selector" get entities from all substates.   if a new substate is added here then we need to add to the selector
        sc.setState({
            entities: entities,
            project: entities.Project,
            currentProjectID: projectID
        });
    }

    @Action(ResetState)
    resetState(sc: StateContext<ProjectObjectStateModel>, action: ResetState) {
        const state = sc.getState();

        sc.setState({
            entities: {},
            project: {},
            currentProjectID: null
        });
    }

    @Action(PrepareRequest)
    prepareRequest(sc: StateContext<ProjectObjectStateModel>, action: PrepareRequest) {
        // prepare ConceptOneRequest
        // Note: The normalize process will create a Root, Reply, and Transaction entity with an ID of 0
        //       When preparing a process transaction a Root, Request, and Transaction entities will have an ID of 1
        //       (then we will denormalize the Root entity with ID = 1)

        const state = sc.getState();

        let projectID = state.currentProjectID;

        let processRoot = {
            '?xml': { '@version': '1.0' },
            ConceptOneRequest: '1'
        };

        let processRequest = {
            ProjectProcess: '1',
            SDK_Version: this.app.dsSystemInfo.objectNode.Product_Version
        };

        let processTran = {
            View: 'Full',
            Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
            Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
            Project: projectID,
            ...action.tranOptions
        };

        let project = cloneDeep(state.project[projectID]);

        sc.patchState({
            project: { ...state.project, [projectID]: project },
            entities: {
                ...state.entities,
                Root: {
                    ...state.entities.Root,
                    [1]: processRoot
                },
                Request: {
                    ...state.entities.Request,
                    [1]: processRequest
                },
                Transaction: {
                    ...state.entities.Transaction,
                    [1]: processTran
                }
            }
        });
    }
}
